package com.cs.ejobin.i18n

enum class AppLanguage(val code: String, val label: String) {
    FR("fr", "Français"),
    EN("en", "English"),
    PT("pt", "Português"),
    ES("es", "Español"),
    HT("ht", "Kreyòl")
}